export default "__VITE_ASSET__0f6d2285__"